"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curl = void 0;

var getMethod = function getMethod(m) {
  if (!m || m === 'GET') {
    return '';
  }

  return '-X POST ';
};

var getHeaders = function getHeaders(h) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!h) {
    return '';
  }

  return Object.keys(h).map(function (k) {
    return "-H \"".concat(k, ": ").concat(h[k], "\" ");
  }).join(sep);
};

var getFile = function getFile(f) {
  if (!f) {
    return '';
  }

  ;
  return "--data @".concat(f, " ");
};

exports.curl = function (options) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var s = [getHeaders(options.headers, sep), getMethod(options.method), getFile(options.file), options.url].join(sep);
  return "curl ".concat(s);
};